import React from "react";
import {
  GOVGR_NOT_FONT_SIZE_14,
  GOVGR_NOT_FONT_SIZE_19,
  GOVGR_NOT_FONT_SIZE_24,
} from "../../conf/styles/GovGrUserInfo";
import ls from "local-storage";
const GovGrUserInfo = ({
  userinfo: {
    name = "ONOMA",
    surname = "EPONIMO",
    afm = "1234567890",
    infonexttoafm = "Κ.Λ.Χ ΑΛΕΞΑΝΔΡΟΥΠΟΛΗΣ",
  },
}) => {
  return (
    <div className="flex items-start justify-center flex-col mr-4 xs:space-y-2 md:space-y-0">
      <div className="flex items-start justify-center space-x-2">
        {name && (
          <span
            className={`xs:${GOVGR_NOT_FONT_SIZE_24} md:${GOVGR_NOT_FONT_SIZE_19}  text-white`}
          >
            {name}
          </span>
        )}
        {surname && (
          <span
            className={`xs:${GOVGR_NOT_FONT_SIZE_24} md:${GOVGR_NOT_FONT_SIZE_19} text-white`}
          >
            {surname}
          </span>
        )}
      </div>
      <div className="flex items-center justify-center space-x-2">
        {afm && (
          <span
            className={`xs:${GOVGR_NOT_FONT_SIZE_19} md:${GOVGR_NOT_FONT_SIZE_14} text-white`}
          >
            {afm}
          </span>
        )}
        {infonexttoafm && (
          <span
            className={`xs:${GOVGR_NOT_FONT_SIZE_19} md:${GOVGR_NOT_FONT_SIZE_14} text-white`}
          >
            {infonexttoafm}
            {/* {ls("port_auth")} */}
          </span>
        )}
      </div>
    </div>
  );
};

export default GovGrUserInfo;
